import React, { useContext } from 'react'
import { ReducerDispatchContext, ReducerContext } from '../reducers/reducerContext.js';
import { setContext, setContextCountry, setContextCustomerType, setVehicleExamples } from '../actions/actionsAppTest';
import { fetchSimulationVehicleDetailsIfNeeded, fetchSimulationVehiclesIfNeeded, fetchSimulationOptionsIfNeeded,
    fetchSimulationAccessoriesIfNeeded } from '../actions/actionsApiSimulation';
import TestContext from '../components/testCriteria/TestContext';

export default function ContTestContext() {

    const dispatch = useContext(ReducerDispatchContext);
    const globalstate = useContext(ReducerContext);

    function onChangeCountryCode(context, perimeterFilter, vehDescType) {
        fetchSimulationVehicleDetailsIfNeeded(globalstate, dispatch, {context:context}, null, false, false);
        fetchSimulationOptionsIfNeeded(globalstate, dispatch, {context:context}, null, null, null, false);
        fetchSimulationAccessoriesIfNeeded(globalstate, dispatch, {context:context}, null, null, false);
        fetchSimulationVehiclesIfNeeded(globalstate, dispatch, {context:context}, null, null, null, false);
        dispatch(setVehicleExamples(context, globalstate.settings));
        dispatch(setContextCountry(context, perimeterFilter, vehDescType));
    }

    function onChangeCustomertype(context) {
        dispatch(setContextCustomerType(context));
    }

    function onChangeContext(context, perimeterFilter, vehDescType) {
        fetchSimulationVehicleDetailsIfNeeded(globalstate, dispatch, {context:context}, null, false);
        fetchSimulationOptionsIfNeeded(globalstate, dispatch, {context:context}, null, false);
        fetchSimulationAccessoriesIfNeeded(globalstate, dispatch, {context:context}, null, null, false);
        fetchSimulationVehiclesIfNeeded(globalstate, dispatch, {context:context}, null, null, null, false);
        dispatch(setVehicleExamples(context, {...globalstate.settings,vehDescType:vehDescType}));
        dispatch(setContext(context, perimeterFilter, vehDescType));
    }

    return (
        <TestContext
            dataContext={globalstate.testCriteria.context}
            settings={globalstate.settings}
            env={globalstate.env}
            onChangeCountryCode={onChangeCountryCode}
            onChangeCustomertype={onChangeCustomertype}
            onChangeContext={onChangeContext}

        />
    );
}
